import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function addProviderClassToBody() {
  const hashIndex = window.location.href.indexOf('#');
  const hashQuery = hashIndex !== -1 ? window.location.href.substring(hashIndex + 1) : '';
  const urlParams = new URLSearchParams(hashQuery.split('?')[1]);

  const providerFromUrl = urlParams.get('provider');
  //console.log(providerFromUrl);

  let providerName: string | null = null;

  if (providerFromUrl) {
    providerName = providerFromUrl.trim();
  } else {
    const providerMeta = document.querySelector('meta[name="provider"]') as HTMLMetaElement;
    if (providerMeta && providerMeta.content) {
      providerName = providerMeta.content.trim();
    }
  }

  if (providerName) {
    document.body.classList.add(`provider-${providerName}`);
  }
}

if (environment.production) {
  const clarityScript = document.createElement('script');
  clarityScript.type = 'text/javascript';
  clarityScript.textContent = `
  (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "rxull8pxlu");
  `;

  document.head.appendChild(clarityScript);
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => addProviderClassToBody())
  .catch((err) => console.error(err));
